import Tag from './Tag';


Tag.install = function(Vue) {
  Vue.component(Tag.name, Tag);
};

export default Tag;
